import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: inline-flex;
  margin-bottom: 1em;
  cursor: pointer;

  /* Override the hover underline to be thinner */
  button:hover span::after {
    height: 1px !important;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.white};
  border: 4px solid #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  margin-right: 8px;

  svg {
    width: 18px;
    height: 18px;
  }
`;
